const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const routes = {
  BASE: BASE_URL,
  ESIM_LIST: BASE_URL + "/api/v1/esims-list",
  BUNDLE_DETAILS: BASE_URL + "/api/v1/bundle-details",
  CHECKOUT_SESSION: BASE_URL + "/api/v1/create-checkout-session",
  CHECKOUT_TOPUP_SESSION: BASE_URL + "/api/v1//create-stripe-topUp-session",
  // Auth
  REGISTER: BASE_URL + "/api/v1/register",
  VERIFY_OTP: BASE_URL + "/api/v1/verify-otp",
  USER_PROFILE: BASE_URL + "/api/v1/userProfile",
  LOGIN: BASE_URL + "/api/v1/login",
  RESEND_OTP: BASE_URL + "/api/v1/resend-otp",
  FORGET_PASSWORD: BASE_URL + "/api/v1/forget",
  UPDATE_PASSWORD: BASE_URL + "/api/v1/password-change",
  GOOGLE_LOGIN: BASE_URL + "/api/v1/google-login",
  UPDATE_USER: BASE_URL + "/api/v1/updateUser",
  SEND_PHONE_OTP_WITH_GOOGLE: BASE_URL + "/api/v1/send-phone-opt-google",
  
  // User Routes
  PACKAGES_LIST: BASE_URL + "/api/v1/getUserPackages",
  USER_LISTING: BASE_URL + "/api/v1/getUserListing",
  PENDING_USER_LISTING: BASE_URL + "/api/v1/getPendingUserListing",
  APPROVE_PENDING_USER: BASE_URL + "/api/v1/approvePendingUser",
  USER_CARD_DATA: BASE_URL + "/api/v1/getUsersCardData",
  GET_ALL_SIM_PACKAGE: BASE_URL + "/api/v1/getPackages",
  UPDATE_PACKAGE: BASE_URL + "/api/v1/updatePackagesPrice",
  ADD_LABEL: BASE_URL + "/api/v1/addLabel",
  UPDATE_PACKAGE_ISFREE: BASE_URL + "/api/v1/package/isfree",
  GET_VENDOR_LIST: BASE_URL + "/api/v1/vendorManagement",
  ADD_VENDOR: BASE_URL + "/api/v1/vendorManagement/add",
  TOGGLE_ISUNLIMITED: BASE_URL + "/api/v1/toggleIsUnlimited",
  TOGGLE_WHATSAPP: BASE_URL + "/api/v1/toggleWhatsapp",
  //Top-up
  GET_TOPUP_PACKAGE_LIST: BASE_URL + "/api/v1/get-topup-packages",
  GET_TOPUP_LIST: BASE_URL + "/api/v1/get-topups",

  //Transactions
  GET_TRANSACTIONS_LIST: BASE_URL + "/api/v1/getUserTransactions",

  // Content Management
  CREATE_SECTION: BASE_URL + "/api/v1/section",
  GET_SECTION: BASE_URL + "/api/v1/get-sections",
  UPDATE_SECTION: BASE_URL + "/api/v1/section",
  DELETE_SECTION: BASE_URL + "/api/v1/delete-section",
  CONTACT_US: BASE_URL + "/api/v1/contact",
  PUBLISH: BASE_URL + "/api/v1/publish",

  // Partner
  CREATE_PARTNER: BASE_URL + "/api/v1/create-partner",
  checkPartnerExists: BASE_URL + "/api/v1/checkPartnerExists",
  GET_ALL_PARTNER: BASE_URL + "/api/v1/partners",
  GET_PARTNER_COUPON_REPORT: BASE_URL + "/api/v1/partners/coupon-report",
  GET_PARTNER_BY_ID: BASE_URL + "/api/v1/partners",
  DELETE_PARTNER: BASE_URL + "/api/v1/partners",
  UPDATE_PARTNER: BASE_URL + "/api/v1/partners",
  SET_PARTNER_PASSWORD: BASE_URL + "/api/v1/set-paasword",

  // Coupons
  GET_COUPONS: BASE_URL + "/api/v1/coupons",
  CREATE_COUPON: BASE_URL + "/api/v1/coupons",
  UPDATE_COUPON: BASE_URL + "/api/v1/coupons",
  DELETE_COUPON: BASE_URL + "/api/v1/coupons",
  VALIDATE_WEBSITE_COUPON: BASE_URL + "/api/v1/validate-website-coupon",

  //resource upload
  RESOURCE_UPLOAD: BASE_URL + "/api/v1/resource-upload",
  RESOURCE_FETCH: BASE_URL + "/api/v1/fetch-resources",
  DELETE_RESOURCE: BASE_URL + "/api/v1/delete-resource",
  UPDATE_PACKAGE_PRICE: `${
    process.env.REACT_APP_API_URL || "http://localhost:8000"
  }/api/v1/update-package-price`,
  DOWNLOAD_SAMPLE_TEMPLATE: `${
    process.env.REACT_APP_API_URL || "http://localhost:8000"
  }/api/v1/download-sample-template`,
  GET_MARGIN: `${
    process.env.REACT_APP_API_URL || "http://localhost:8000"
  }/api/v1/settings/margin`,
  GET_PROCESSING_FEE: `${
    process.env.REACT_APP_API_URL || "http://localhost:8000"
  }/api/v1/settings/margin/getprocessingFee`,
  PROCESSING_FEE: `${
    process.env.REACT_APP_API_URL || "http://localhost:8000"
  }/api/v1/settings/margin/processingFee`,
};
export default routes;
